type TConfig = {
  common: string[];
  feature: string;
};

export const appStoreLinksConfig: TConfig = {
  common: ['CommonUI.Controls'],
  feature: 'Feature.Landing'
};

export default {
  appStoreLinksConfig
};
